/*
 * @Description: 已支付
 * @Date: 2020-12-12 17:48:46
 */
import fields from './fields';
import search from './search';

import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { csoCustomerOrder } from '@/api/ajax';

let example = new TableRenderClass({ fields, search });

let metaArray = {
  '1-2':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '1-3':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '1-1':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '1-13':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '2-4':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '2-5':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '2-6':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '1-14':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '1-15':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '3-3':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '3-2':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '3-1':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '4-7':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '4-8':
    '【商务服务费】计算公式为：终端结算总金额×（1+供应商服务费率）×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '4-9':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '5-11':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '5-12':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '5-10':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '10-4':
    '【商务服务费】计算公式为：项目当期收入×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '11-6':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  '11-5':
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本。',
  individualPark:
    '【商务服务费】计算公式为：终端结算总金额×（1+增值税率）x商务服务费率。商务服务费率是完税成本'
};

let filedsArray = {
  //园区个体
  individualPark: [
    'index',
    'orderNo',
    'projectName',
    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //汇总申报-三级汇总 1-2
  '1-2': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '1-3': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //汇总申报-四级汇总 1-1
  '1-1': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  // 工业-ASP(线下支付)-P-C
  '1-13': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //委托代开-三级代开 2-4
  '2-4': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //委托代开-二级代开 2-5
  '2-5': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '2-6': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  // 工业(线下支付)-P-C
  '1-14': [
    'index',
    'orderNo',
    'projectName',
    'finishSumTaskPrice',
    'tax',
    'commission',
    'commission2',
    'totalPrice',
    'payStatus'
  ],
  // ASP(线下支付)-P-C
  '1-15': [
    'index',
    'orderNo',
    'projectName',
    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //委托代发-工业/ASP-P-C 3-3 3-2
  '3-3': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '3-2': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //委托代发-工业-ASP-P-C 3-1
  '3-1': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //运营基地-工业-运营基地-C 4-7
  '4-7': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //运营基地-ASP-运营基地-C 4-8
  '4-8': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'commission2',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //运营基地-运营基地-C 4-9
  '4-9': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //个体-二级个体（工业-个体；ASP-个体） 5-11 5-12
  '5-11': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '5-12': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  //个体-三级个体（工业-ASP-个体） 5-10
  '5-10': [
    'index',
    'orderNo',
    'projectName',
    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  // 委托代开（线上）
  '10-4': [
    'index',
    'orderNo',
    'projectName',

    'monthTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '11-6': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ],
  '11-5': [
    'index',
    'orderNo',
    'projectName',

    'finishSumTaskPrice',
    'tax',
    'commission',
    'totalPrice',
    'payStatus'
  ]
};
// 页面入口
// const part = example.createPart({
//   name: '订单详情',
//   list: listPayOrderPeopleAndSupplie,
//   fields: [
//     'index',
//     'orderNo',
//     'projectName',
//
//     'finishSumTaskPrice',
//     'tax',
//     'commission',
//     'totalPrice',
//     'payStatus'
//   ]
// });

let constructionGetter = function(type = '1-2') {
  const part = example.createPart({
    name: '订单详情',
    list: csoCustomerOrder.oneOrderBusServiceOrder,
    fields: filedsArray[type]
  });
  return {
    name: '订单详情',
    meta: metaArray[type],
    childMenu: [
      { ...part, individualAjax: csoCustomerOrder.oneOrderBusServiceOrder }
    ]
  };
};

// individualAjax 为独立注册字段，用于获取总价接口
export default constructionGetter;
const part2 = example.createPart({
  name: '订单详情',
  list: csoCustomerOrder.oneOrderBusServiceOrder,
  fields: filedsArray['1-2']
});
export const normal = {
  name: '订单详情',
  meta: metaArray['1-2'],
  childMenu: [
    { ...part2, individualAjax: csoCustomerOrder.oneOrderBusServiceOrder }
  ]
};
